import { Box, Drawer, IconButton, useMediaQuery } from "@mui/material";

import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom"; // Classroom
import BarChartIcon from "@mui/icons-material/BarChart"; // Performance
import DiamondIcon from "@mui/icons-material/Diamond"; // Pricing Plan

import Header from "../../../SAPPages/components/header/Header";
import Sidebar from "../../../SAPPages/components/sidebar/Sidebar";
import InsertChartOutlinedIcon from "@mui/icons-material/InsertChartOutlined";
import { FaChalkboardTeacher, FaBookOpen, FaChalkboard } from 'react-icons/fa'; // Icons for Classroom and Demo

import PaymentIcon from '@mui/icons-material/Payment';
import { useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import logo from "../../../assets/Header/STM_logo.png";
import { Icon } from "@iconify/react/dist/iconify.js";

import { MdOutlineQrCodeScanner } from "react-icons/md";



const TestPrepDashboardLayout = ({ children }) => {
  const headerHeight = 70;
  const childrenHeaderHeight = 10;
  const sidebarWidth = 150;

  const [mobileOpen, setMobileOpen] = useState(false);
  const isSmallScreen = useMediaQuery("(max-width:768px)");

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const QRIcon = () => (
  <img src='/scanner.png' alt="Custom Icon" style={{ width: '30px', height: '30px' }} />
);

  const menuItems = [
    {
      text: "Dashboard",
      icon: <HomeOutlinedIcon />,
      path: "/test-prep/testprepdashboard",
    },
    {
      text: "Classes",
      icon: <Icon icon="mdi:book-open" />,
      path: "/test-prep/classes",
    },
     { text: "Classroom", icon:    <Icon icon="streamline:class-lesson" /> ,path:"/test-prep/classroom" },
     { text: "Demos", icon:  <Icon icon="mdi:television" /> , path:"/test-prep/demos"},
     {text:"Payments" , icon:<PaymentIcon/> , path:"/test-prep/payment-history"},


    { text: "Performance", icon: <InsertChartOutlinedIcon />,  path:"/test-prep/performance" },
    { text: "My Qr Code", icon: <MdOutlineQrCodeScanner />,  path:"/test-prep/myqrcode" },

    // { text: "Documents", icon: <DescriptionOutlinedIcon /> },

    // { text: "Pricing Plan", icon: <DiamondIcon /> },
    // { text: "Setting", icon: <ArticleOutlinedIcon /> },
  ];

  return (
    <Box sx={{ display: "flex" }}>
      {/* Sidebar for large screens */}
      {!isSmallScreen && (
        <Box
          sx={{
            zIndex: 1,
            width: sidebarWidth,
            flexShrink: 0,
            position: "fixed",
            top: headerHeight,
            left: 0,
            bottom: 0,
            bgcolor: "#FBF5FF",
            borderRight: "1px solid #eee",
            overflowY: "auto",
            overflowX: "hidden",
            "&::-webkit-scrollbar": { display: "none" },
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
        >
          <Sidebar menuItems={menuItems} />
        </Box>
      )}

      {/* Sidebar for small screens using Drawer */}
     {isSmallScreen && (
  <Drawer
    open={mobileOpen}
    onClose={handleDrawerToggle}
    variant="temporary"
    ModalProps={{ keepMounted: true }}
    sx={{
      "& .MuiDrawer-paper": {
        width: sidebarWidth,
        bgcolor: "#FBF5FF",
        borderRight: "1px solid #eee",
        // ensure the paper itself is the scroll container
        overflowY: "auto",
        overflowX: "hidden",

        /* Hide scrollbar for Chrome, Safari, Edge */
        "&::-webkit-scrollbar": {
          width: 0,
          height: 0,
        },

        /* Hide scrollbar for Firefox */
        scrollbarWidth: "none",

        /* Hide scrollbar for IE and Edge */
        msOverflowStyle: "none",

        // ensure child elements don't reintroduce scrollbars
        "& *": {
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        },
        "& *::-webkit-scrollbar": {
          display: "none",
        },
      },
    }}
  >
     {/* Logo */}
                        <div style={{  display:"flex", justifyContent:"center", alignItems:"center", marginTop:10, marginBottom:5}}>
                          <img src={logo} alt="STM Logo" style={{ height: 50, width: 70 }} />
                        </div>
    <Sidebar menuItems={menuItems} />
  </Drawer>
)}


      <Box sx={{ flex: 1, ml: !isSmallScreen ? `${sidebarWidth}px` : 0 }}>
        {/* Header */}
   
 
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            height: headerHeight,
            bgcolor: "white",
            borderBottom: "1px solid #eee",
            zIndex: 1000,
          }}
        >
    
          <Header isSmallScreen={isSmallScreen} handleDrawerToggle={handleDrawerToggle} />
        </Box>

   

      
       
        {/* Dynamic Page Content */}
        <Box
          sx={{
            mt: `${childrenHeaderHeight}px`,
            p: 3,
            pt: `${headerHeight + 16}px`,
            minHeight: "100vh",
            bgcolor: "#fafafa",
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default TestPrepDashboardLayout;


 